import React from "react";
import type {DeserializedGridCellParams} from "../../../../../../components/muix-data-grid/MuiXColumnDefinitions.ts";
import type {PartGridGroupModel, PartGridRowModel} from "../CategorizationTableDataModel.ts";
import {Chip} from "@mui/material";
import {
    MatPartReviewRowState,
    MatPartReviewRowStateToString
} from "../../../../../../services/classes/MaterializedClasses.ts";

const SEEN_ERROR_STATUS = new Set<string>();

type Props = DeserializedGridCellParams<PartGridRowModel>;
export const StateCell: React.FC<Props> = ({row, rowNode}) => {
    let state: MatPartReviewRowState | '' = '';

    if (rowNode.type === 'leaf') {
        const partRow = row as PartGridRowModel;
        state = partRow.state;
    } else if (rowNode.type === 'group') {
        const groupRow = row as unknown as PartGridGroupModel;
        const n = groupRow.state_agg.length;
        if (n > 1) {
            return `${n} values`;
        }
        if (n === 1) {
            state = groupRow.state_agg[0];
        }
    }

    if (!state) return <></>;
    if (!MatPartReviewRowState[state]) {
        if (!SEEN_ERROR_STATUS.has(state)) {
            console.error('Unknown part state:', state);
            SEEN_ERROR_STATUS.add(state);
        }
        return <Chip
            label={'ERR: ' + JSON.stringify(state)}
            className="chip error"
            color="error"
        />
    }
    return <Chip
        label={MatPartReviewRowStateToString(state)}
        className={`chip ${state}`}
        sx={{maxHeight: '24px'}}
    />
}
